import {abnAmroSkin} from './AbnAmroSkin.tsx';
import {bunqSkin} from './BunqSkin.tsx';
import {paletteSkinFor} from './CardPalette.tsx';
import {ingSkin} from './IngSkin.tsx';
import {knabSkin} from './KnabSkin.tsx';
import {rabobankSkin} from './RabobankSkin.tsx';
import type {BankCardSkin} from './types.ts';

export {ChipTone} from './types.ts';
export type {BankCardSkin} from './types.ts';

const BANK_DESIGNS: Record<string, BankCardSkin> = {
    RABOBANK_RABONL2U: rabobankSkin,
    RABOBANK_NL: rabobankSkin,
    ING_INGBNL2A: ingSkin,
    ING_WB_INGBNL2A: ingSkin,
    ABNAMRO_ABNANL2A: abnAmroSkin,
    KNAB_KNABNL2H: knabSkin,
    BUNQ_BUNQNL2A: bunqSkin,
};

export function getBankCardSkin(institutionId: string, paletteSeed: string): BankCardSkin {
    return BANK_DESIGNS[institutionId.trim()] ?? paletteSkinFor(paletteSeed);
}
